import {applyMiddleware, compose, createStore} from "redux";
import promiseMiddleware from "redux-promise-middleware";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const promiseMidd = promiseMiddleware();
export const createHITCardStore = () => createStore(rootReducer, compose(applyMiddleware(thunk), applyMiddleware(promiseMidd)));

export const store = createHITCardStore();

// store.subscribe(() => console.log(store.getState()));


// WEBPACK FOOTER //
// ./src/redux/state.js